class ComprasionTable extends HTMLElement {
  constructor() {
    super();

    this.initArrows();
    this.comprasionTable = this.querySelector('.comprasion-table__table');
    this.leftArrow = this.querySelector('.js-scroll-left');
    this.rightArrow = this.querySelector('.js-scroll-right');

    this.leftArrow?.addEventListener('click', this.scrollLeft.bind(this));
    this.rightArrow?.addEventListener('click', this.scrollRight.bind(this));
    this.comprasionTable?.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', this.initArrows);
  }

  scrollLeft(event) {
    event.preventDefault();

    if(!event.currentTarget.classList.contains('comprasion-table__arrow--active')) return;

    const scrollWidth = window.innerWidth <= 750 ? 160 : 200;

    this.comprasionTable.scrollLeft -= scrollWidth;
    this.rightArrow.classList.add('comprasion-table__arrow--active');

    if(this.comprasionTable.scrollLeft - scrollWidth <= 0) {
      this.leftArrow.classList.remove('comprasion-table__arrow--active');
    }
  }

  scrollRight(event) {
    event.preventDefault();

    if(!event.currentTarget.classList.contains('comprasion-table__arrow--active')) return;

    const scrollWidth = window.innerWidth <= 750 ? 160 : 200;

    this.comprasionTable.scrollLeft += scrollWidth;
    this.leftArrow.classList.add('comprasion-table__arrow--active');

    if(this.comprasionTable.scrollLeft + scrollWidth >= this.comprasionTable.scrollWidth - this.comprasionTable.clientWidth) {
      this.rightArrow.classList.remove('comprasion-table__arrow--active');
    }
  }

  onScroll(event) {
    this.rightArrow.classList.add('comprasion-table__arrow--active');
    this.leftArrow.classList.add('comprasion-table__arrow--active');

    if(event.currentTarget.scrollLeft >= event.currentTarget.scrollWidth - event.currentTarget.clientWidth) {
      this.rightArrow.classList.remove('comprasion-table__arrow--active');
    }

    if(event.currentTarget.scrollLeft <= 0) {
      this.leftArrow.classList.remove('comprasion-table__arrow--active');
    }
  }

  initArrows() {
    const sliderArros = document.querySelector('.comprasion-table__arrows');
    const table = document.querySelector('.comprasion-table__table');

    if (sliderArros && table.clientWidth >= table.scrollWidth) {
      sliderArros.classList.add('comprasion-table__arrows--hidden');
    } else if (table.clientWidth < table.scrollWidth) {
      sliderArros.classList.remove('comprasion-table__arrows--hidden');
    }
  }
}

customElements.define('comprasion-table', ComprasionTable);